export default function lerp(a, b, t) {
  return a + (b - a) * t;
}